import { useEffect, useState } from 'react';
import './ScrollToTopButton.scss';

const SCROLL_THRESHOLD = 200;
const KAKAO_CHANNEL_URL = 'http://pf.kakao.com/_mrfxiX';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* 카카오 채널 버튼은 스크롤과 관계없이 항상 맨 아래에 보이고, TOP 버튼은 스크롤하면 그 바로 위에 나타난다 */}
      <a
        className="kakao-channel-btn"
        href={KAKAO_CHANNEL_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="카카오 채널로 문의하기"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3C6.48 3 2 6.54 2 10.9c0 2.82 1.87 5.3 4.69 6.7l-.95 3.48c-.08.3.26.54.52.37l4.15-2.74c.52.07 1.05.1 1.59.1 5.52 0 10-3.54 10-7.9S17.52 3 12 3z" />
        </svg>
        <span>문의</span>
      </a>
      {visible && (
        <button
          type="button"
          className="scroll-to-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="맨 위로 이동"
        >
          TOP
        </button>
      )}
    </>
  );
}
